// 封装fetch请求为await函数，支持传递请求体
export async function fetchResource(
  url: string,
  method = "GET",
  body = null,
  headers = {},
) {
  const defaultHeaders = {
    "Content-Type": "application/json",
  }

  // 合并默认头部信息和自定义头部信息
  const requestHeaders = new Headers({ ...defaultHeaders, ...headers })

  try {
    // 发起fetch请求并等待响应，如果是POST或PUT请求，需要传递请求体
    const response = await fetch(url, {
      method,
      headers: requestHeaders,
      body: body ? JSON.stringify(body) : undefined, // 如果是null，则不传递body
    })

    // 检查响应状态
    if (!response.ok) {
      throw new Error(`${response.status}`)
    }

    // 解析响应体为JSON
    const data = await response.json()

    // 返回数据
    return data
  } catch (error) {
    // 处理错误
    console.error(error)
    throw error
  }
}
